module.exports = __webpack_public_path__ + "static/media/bg9.7d2facc5.jpg";